// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZrmV2WebApiHandler_inquiries,
  RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Path,
  RentalManagerAccountViewZrmV2WebApiHandler_leases,
  RentalManagerAccountViewZrmV2WebApiHandler_leases_Path,
  RentalManagerAccountViewZrmV2WebApiHandler_list,
  RentalManagerAccountViewZrmV2WebApiHandler_list_Path,
  RentalManagerAccountViewZrmV2WebApiHandler_options,
  RentalManagerAccountViewZrmV2WebApiHandler_options_Path,
  RentalManagerAccountViewZrmV2WebApiHandler_payments,
  RentalManagerAccountViewZrmV2WebApiHandler_payments_Path,
  RentalManagerAccountViewZrmV2WebApiHandler_units,
  RentalManagerAccountViewZrmV2WebApiHandler_units_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  AccountViewListingGroupsResponseDto,
  AccountViewListingOptionsDto,
  AccountViewMultiplexUnitsResponseDto,
  AccountViewTableCellDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface InquiriesParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface LeasesParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface PaymentsParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface UnitsParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export type RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, InquiriesParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_inquiries_GetKey = (getParams: InquiriesParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_inquiries_queryOptions = (
  getParams: InquiriesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_inquiries_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_inquiries(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property inquiries status
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_inquiries = (
  getParams: InquiriesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_inquiries_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_inquiries.getKey =
  RentalManagerAccountViewZrmV2WebApiHandler_inquiries_GetKey;

export type RentalManagerAccountViewZrmV2WebApiHandler_leases_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, LeasesParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_leases_GetKey = (getParams: LeasesParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_leases_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_leases_queryOptions = (
  getParams: LeasesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_leases_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_leases(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property leases status
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_leases = (
  getParams: LeasesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_leases_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_leases_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_leases.getKey = RentalManagerAccountViewZrmV2WebApiHandler_leases_GetKey;

export type RentalManagerAccountViewZrmV2WebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingGroupsResponseDto,
  unknown,
  AccountViewListingGroupsResponseDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property list with multiplex groups view
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_list.getKey = RentalManagerAccountViewZrmV2WebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmV2WebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_options_queryOptions = (
  getParams: OptionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_options(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get account view property listing options
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_options = (
  getParams: OptionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_options_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_options_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_options.getKey =
  RentalManagerAccountViewZrmV2WebApiHandler_options_GetKey;

export type RentalManagerAccountViewZrmV2WebApiHandler_payments_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, PaymentsParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_payments_GetKey = (getParams: PaymentsParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_payments_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_payments_queryOptions = (
  getParams: PaymentsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_payments_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_payments(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property payments status
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_payments = (
  getParams: PaymentsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_payments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_payments_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_payments.getKey =
  RentalManagerAccountViewZrmV2WebApiHandler_payments_GetKey;

export type RentalManagerAccountViewZrmV2WebApiHandler_units_Options = UseQueryOptions<
  AccountViewMultiplexUnitsResponseDto,
  unknown,
  AccountViewMultiplexUnitsResponseDto,
  readonly [string, UnitsParams]
>;

const RentalManagerAccountViewZrmV2WebApiHandler_units_GetKey = (getParams: UnitsParams) =>
  [RentalManagerAccountViewZrmV2WebApiHandler_units_Path, getParams] as const;

export const RentalManagerAccountViewZrmV2WebApiHandler_units_queryOptions = (
  getParams: UnitsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmV2WebApiHandler_units_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmV2WebApiHandler_units(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view unit list for a multiplex
 */
export const useRentalManagerAccountViewZrmV2WebApiHandler_units = (
  getParams: UnitsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmV2WebApiHandler_units_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmV2WebApiHandler_units_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmV2WebApiHandler_units.getKey = RentalManagerAccountViewZrmV2WebApiHandler_units_GetKey;
